import React, { ReactElement } from "react";
import { useFormikContext } from "formik";
import { FieldWrapper } from "./FieldWrapper";
import { border, Box } from "@chakra-ui/react";
import {
  AutoComplete,
  AutoCompleteGroup,
  AutoCompleteTag,
  AutoCompleteInput,
  AutoCompleteItem,
  AutoCompleteList,
} from "@choc-ui/chakra-autocomplete";
import { Break } from "../../styled/Break";
import { isDesktopHook } from "../../../Hooks";

export interface Option {
  label: string;
  value: string;
}

interface Props {
  options: Option[];
  name: string;
  tagScheme?: string;
  variant?: string;
  placeholder?: string;
  label?: string;
  multiple?: boolean;
  borderColor?: string;
  borderColorHover?: string;
  maxSelections?: number;
  maxSelectionsMobile?: number;
}

export function AutocompleteField({
  options,
  name,
  tagScheme = "blue",
  label,
  multiple = true,
  borderColor = "#0088cc",
  borderColorHover = "#0088cc",
  maxSelections = 3,
}: Props): ReactElement {
  const formikProps = useFormikContext();

  const onChange = (val) => {
    formikProps.setFieldValue(name, val);
  };

  const isDesktop = isDesktopHook();

  const onSelected =
    isDesktop && maxSelections >= 2
      ? { borderColor: borderColorHover }
      : {
          height: "20vh",
          borderColor: borderColorHover,
        };

  return (
    <FieldWrapper name={name} label={label}>
      <Box
        border={`solid 2px ${borderColor}`}
        borderColor={borderColor}
        borderRadius="md"
        borderWidth="2px"
        _hover={onSelected}
        _active={onSelected}
        _focus={onSelected}
        background="white"
      >
        <AutoComplete
          openOnFocus
          onChange={onChange}
          multiple={multiple}
          maxSelections={maxSelections}
          border="solid 0px black"
          focusInputOnSelect={true}
          value={formikProps.values[name]}
        >
          <AutoCompleteInput border="solid 0px black" variant="no_border" fontFamily="linotte">
            {({ tags }) =>
              tags.map((tag, tid) => {
                return (
                  <AutoCompleteTag
                    key={tid}
                    label={tag.label}
                    onClick={tag.onRemove}
                    onRemove={tag.onRemove}
                    _hover={{ cursor: "pointer" }}
                    // bg={borderColor}
                    // color="white"
                    bg="white"
                    color={borderColor}
                    borderColor={borderColor}
                    borderWidth="1px"
                    borderStyle="grove"
                    fontSize="1.2rem"
                    fontFamily="galdeano"
                    // textTransform="uppercase"
                  />
                );
              })
            }
          </AutoCompleteInput>
          <Break height="2vh" />
          <AutoCompleteList>
            <AutoCompleteGroup>
              {options.map((option, id) => (
                <AutoCompleteItem key={`option-${id}`} value={option.value} _selected={{ fontWeight: "extrabold" }}>
                  {option.label}
                </AutoCompleteItem>
              ))}
            </AutoCompleteGroup>
          </AutoCompleteList>
        </AutoComplete>
      </Box>
    </FieldWrapper>
  );
}
